import { View } from 'react-native';
import { Text } from '@/components/Text';

import { styles } from './styles';

export function ContentText() {
  return (
    <View style={styles.container}>
      <Text style={styles.text}>
        {`•`} Wie lang soll das Wort sein? Setzen Sie bei{' '}
        <Text style={styles.bold}>Silbenanzahl</Text> z.B. nur bei der 2 einen
        Haken, wenn Sie ausschließlich zweisilbige Wörter trainieren möchten.
      </Text>
      <Text style={styles.text}>
        {`•`} Soll das Wort Konsonantencluster enthalten? Falls ja, wählen Sie
        bei der <Text style={styles.bold}>Silbenstruktur</Text> „komplex".
      </Text>
      <Text style={styles.text}>
        {`•`} Auf welcher Silbe soll das Wort betont sein? Setzen Sie den Haken
        bei <Text style={styles.bold}>Wortakzent</Text> z.B. bei der 1, wenn Sie
        nur auf der ersten Silbe betonte Wörter trainieren möchten.
      </Text>
      <Text style={styles.text}>
        {`•`} Soll das Wort häufig im Deutschen vorkommen? Falls ja, wählen Sie
        bei <Text style={styles.bold}>Wortfrequenz</Text> „hoch".
      </Text>
      <Text style={styles.text}>
        {`•`} Soll das Wort bestimmte Laute enthalten? Unter{' '}
        <Text style={styles.bold}>Phoneme</Text> wählen Sie Laute und deren
        Position im Wort aus.
      </Text>
      <Text style={styles.text}>
        {`•`} Zusätzlich zu den Worteigenschaften können Sie nach einzelnen
        Wörtern suchen (<Text style={styles.bold}>Wortsuche</Text>) oder sich
        nur Wörter einer semantischen Kategorie anzeigen lassen (
        <Text style={styles.bold}>Kategoriesuche</Text>). Tippen Sie hierzu
        Wörter oder semantische Kategorien in das Suchfeld ein.
      </Text>
    </View>
  );
}
